<template>
  <PatientInfo v-if="patient_id != null" :patient_id="patient_id">
    <template v-slot:action-bt> . </template>
  </PatientInfo>
  <!--  -->
  <div style="background-color: beige" class="py-4 container-fluid">
    <div class="row">
      <div class="col-sm-2" :style="' border-right:1px solid black'">
        <div :style="'color: purple; font-weight: bold; '">
          Treatment History
        </div>
        <div
          v-for="records in past_records"
          :key="records.id"
          :style="'background-color: white; border:1px solid black; border-radius:4px; '"
        >
          <span>
            <u
              ><span style="font-weight: bold"> - </span>
              <a :href="'/visit_summary/' + records.id">{{
                am_pm(records.created_at)
              }}</a></u
            >
          </span>
        </div>
        <div v-if="past_records.length < 1">
          <span>No past Visit Records</span>
        </div>
      </div>

      <div class="col-sm-10">
        <div class="row">
          <div class="col-xl-3 col-sm-6 mb-xl-0">
            <mini-statistics-card
              title="send to "
              value="Laboratory"
              @click="navigate_loc('/consultation_at_lab/' + visit_id)"
              :percentage="{
                value: '+5%',
                color: 'text-success',
              }"
              :icon="{
                component: '',
                background: iconBackground,
              }"
              direction-reverse
            />
          </div>

          <div class="col-xl-3 col-sm-6 mb-xl-0">
            <mini-statistics-card
              title="send to "
              value="Radiology"
              @click="navigate_loc('/consultation_at_radiology/' + visit_id)"
              :percentage="{
                value: '+5%',
                color: 'text-success',
              }"
              :icon="{
                component: '',
                background: iconBackground,
              }"
              direction-reverse
            />
          </div>

          <div class="col-xl-3 col-sm-6 mb-xl-0">
            <mini-statistics-card
              title="send to "
              value="Nursing"
              @click="navigate_loc('/consultation_at_nursing/' + visit_id)"
              :percentage="{
                value: '+5%',
                color: 'text-success',
              }"
              :icon="{
                component: '',
                background: iconBackground,
              }"
              direction-reverse
            />
          </div>

          <div class="col-xl-3 col-sm-6 mb-xl-0">
            <mini-statistics-card
              title="send to "
              value="Pharmacy"
              @click="navigate_loc('/consultation_at_pharmacy/' + visit_id)"
              :percentage="{
                value: '+5%',
                color: 'text-success',
              }"
              :icon="{
                component: '',
                background: iconBackground,
              }"
              direction-reverse
            />
          </div>

          <div class="col-xl-3 col-sm-6 mb-xl-0">
            <mini-statistics-card
              title="Add -"
              value="Diagnosis"
              @click="navigate_loc('/consultation_at_diagnosis/' + visit_id)"
              :percentage="{
                value: '+5%',
                color: 'text-success',
              }"
              :icon="{
                component: '',
                background: iconBackground,
              }"
              direction-reverse
            />
          </div>

          <div class="col-xl-3 col-sm-6 mb-xl-0">
            <mini-statistics-card
              title="send to "
              value="Inpatient"
              @click="navigate_loc('/consultation_at_inpatient/' + visit_id)"
              :percentage="{
                value: '+5%',
                color: 'text-success',
              }"
              :icon="{
                component: '',
                background: iconBackground,
              }"
              direction-reverse
            />
          </div>
        </div>

        <!--  -->
      </div>
    </div>
    <!--  -->
  </div>
  <div class="card">
    <consultation_notes :visitId="visit_id" /> 
  </div>
</template>
<script>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import TimeConvert from "@/timezone/utc_local_time.js";
import PatientInfo from "../Patients/components/patient_biodata.vue";
import consultation_notes from "./consultation_notes.vue";

// import ReportsBarChart from "@/examples/Charts/ReportsBarChart.vue";
// import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
// import TimelineList from "../components/TimelineList.vue";
// import TimelineItem from "../components/TimelineItem.vue";
// import ProjectsCard from "../components/ProjectsCard.vue";

import { generalApiRequest } from "../../api/apiIndex";
import {
  faCreditCard,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";
export default {
  name: "VisitsDashboard",
  data() {
    return {
      iconBackground: "bg-gradient-success",
      faCreditCard,
      faScrewdriverWrench,
      visit_id: this.$route.params.visitid,
      past_records: [],
      patient_id: null,
    };
  },
  components: {
    MiniStatisticsCard,
    PatientInfo,
    consultation_notes,
    // ReportsBarChart,
    // GradientLineChart,
    // ProjectsCard,
    // TimelineList,
    // TimelineItem,
  },
  methods: {
    navigate_loc(route) {
      // console.log(route);
      window.location.href = route;
    },
    async mountPastRecords() {
      const url = "get_all_visits_dates";
      const body = { visit_id: this.visit_id };
      const res = await generalApiRequest(url, "GET", body, 1);
      this.past_records = res.data;
      if (res.data.length > 0) {
        this.patient_id = res.data[0].patient_id;
      }
    },
    am_pm(param) {
      return TimeConvert(param);
    },
  },

  mounted() {
    this.mountPastRecords();
    // const visit_id = this.$route.params.storeLocation;
    // this.visit_id = visit_id;
  },
};
</script>

<style scoped>
td,
th {
  text-align: center; /* Horizontally center the content */
  vertical-align: middle; /* Vertically center the content */
  padding: 8px; /* Optional: Adds some space inside the cells */
  border-top: 1px solid #ddd; /* Optional: Adds borders for visibility */
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto; /* Automatically adjusts column width based on content */
  word-wrap: break-word; /* Allows long words to break and wrap */
}

td {
  padding: 8px;
  border: 1px solid #ddd;
  word-wrap: break-word; /* Break long words */
  word-break: break-all; /* Break the word at any point, even between characters */
  white-space: normal; /* Allow content to wrap naturally */
  font-size: 16px; /* Default font size */
  overflow: hidden; /* Hide content overflow */
}

@media (max-width: 768px) {
  td {
    font-size: 12px; /* Reduce font size for smaller screens */
    padding: 6px; /* Adjust padding */
  }
}

@media (max-width: 480px) {
  td {
    font-size: 10px; /* Even smaller font size for small screens */
    padding: 4px; /* Reduce padding further */
  }

  table {
    display: block;
    overflow-x: auto; /* Allow horizontal scrolling for very small screens */
    -webkit-overflow-scrolling: touch; /* Smooth scrolling on mobile */
  }
}
</style>
